import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import "./RevenueChart.css";

const RevenueChart = ({ revenueData, title }) => {
  const [activeIndex, setActiveIndex] = React.useState(null);

  // Transform date format for better display
  const data = revenueData.map((item, index) => {
    const date = new Date(item.date);
    const formattedDate = `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}`;
    return {
      date: formattedDate,
      revenue: item.revenue,
      id: index,
    };
  });

  const handleMouseEnter = (_, index) => {
    setActiveIndex(index);
  };

  const handleMouseLeave = () => {
    setActiveIndex(null);
  };

  const primaryColor = "#8560fc";
  const hoverColor = "#7045fb";

  // Format Y-axis ticks to show only integers
  const formatYAxis = (tickItem) => Math.floor(tickItem);

  return (
    <div className="revenue-chart">
      <h3>{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          margin={{ top: 20, right: 0, left: 20, bottom: 30 }}
          onMouseLeave={handleMouseLeave}
        >
          <CartesianGrid strokeDasharray="3 3" opacity={0.2} />
          <XAxis
            dataKey="date"
            tick={{ fill: "#666" }}
            tickLine={{ stroke: "#666" }}
          />
          <YAxis
            tick={{ fill: "#666" }}
            tickLine={{ stroke: "#666" }}
            tickFormatter={formatYAxis}
            allowDecimals={false}
          />
          <Tooltip
            cursor={false}
            contentStyle={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              border: "none",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
            }}
            formatter={(value) => [`₹ ${value.toLocaleString()}`, "Revenue"]}
          />
          <Bar
            dataKey="revenue"
            radius={[4, 4, 0, 0]}
            onMouseEnter={handleMouseEnter}
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index === activeIndex ? hoverColor : primaryColor}
                className="bar-cell"
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default RevenueChart;
